import { Injectable } from '@angular/core';
import { AbstractService } from './abstract.service';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class DiagnosisDSM5Service extends AbstractService{

  endpoint = environment.serverUrl + 'diagnosis-dsm5';

  constructor(http: HttpClient) {
      super(http);
  }


  root() {
    return this.http.get(`${this.endpoint}/root`);
  }

  getById(id) {
    return this.http.get(`${this.endpoint}/by-id/${id}`);
  }

  descendants(id) {
    return this.http.get(`${this.endpoint}/descendants?id=${id}`);
  }

  getByName(label) {
    return this.http.post(`${this.endpoint}/descendants-by-name`, {
      name: label
    })
  }

}
